__turbopack_context__.v({
  "Breadcrumb": "page-module__57i6iW__Breadcrumb",
  "Categories": "page-module__57i6iW__Categories",
  "Date": "page-module__57i6iW__Date",
  "PageCurrent": "page-module__57i6iW__PageCurrent",
  "PageNumber": "page-module__57i6iW__PageNumber",
  "Pagination": "page-module__57i6iW__Pagination",
  "Tags": "page-module__57i6iW__Tags",
  "contentBanner": "page-module__57i6iW__contentBanner",
  "grid_post": "page-module__57i6iW__grid_post",
  "image_post": "page-module__57i6iW__image_post",
  "innerNavigation": "page-module__57i6iW__innerNavigation",
  "itemTag": "page-module__57i6iW__itemTag",
  "links": "page-module__57i6iW__links",
  "mainSingleBlog": "page-module__57i6iW__mainSingleBlog",
  "quote_post": "page-module__57i6iW__quote_post",
  "related_posts": "page-module__57i6iW__related_posts",
  "rowReverse": "page-module__57i6iW__rowReverse",
  "separator": "page-module__57i6iW__separator",
  "splitPost": "page-module__57i6iW__splitPost",
  "tagsTemas": "page-module__57i6iW__tagsTemas",
});
